module.exports = {
	LEVELS: {
		VERBOSE: 'verbose',
		DEBUG: 'on',
		OFF: 'off'
	}
};


//////////////////
// WEBPACK FOOTER
// ./constants/logging.js
// module id = 16
// module chunks = 0 5 20